import { createAction } from 'redux/helpers/actions';
import types from './types';

export default {
  getNetworkFeed: (data) => createAction(types.getNetworkFeed, data),
  removeNetworkFeedItem: (data) => createAction(types.removeNetworkFeedItem, data),

  resolveNetworkShare: (data, config) => createAction(types.resolveNetworkShare, data, config),
  publishNetworkShare: (data, config) => createAction(types.publishNetworkShare, data, config),
  withdrawNetworkShare: (data) => createAction(types.withdrawNetworkShare, data),

  getNetworkSettings: (data) => createAction(types.getNetworkSettings, data),
  updateNetworkSettings: (data, config) => createAction(types.updateNetworkSettings, data, config),
  getNetworkAutoPostCandidates: (data) => createAction(types.getNetworkAutoPostCandidates, data),
};
